import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ConfluencePricingEndOfTrialPremiumToStandardQuery } from './ConfluencePricingEndOfTrialPremiumToStandardQuery';

export function preloadPricingEOTPremiumToStandardQuery() {
	const { cloudId, edition, isLoggedIn } = getPreloaderFnContext();
	const queries: Promise<any>[] = [];

	if (isLoggedIn && cloudId && edition === ConfluenceEdition.PREMIUM) {
		queries.push(
			queryAgg({
				query: ConfluencePricingEndOfTrialPremiumToStandardQuery,
				variables: {
					cloudId,
					productKey: 'confluence.ondemand',
				},
			}),
		);
	}

	return waitForAllReturnWhenError(queries);
}
